import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentAllGet = {
    path: "/consent/all",
    method: RouteHttpVerb.GET
};
export { locationRestConsentAllGet };
